import { CreateProductGroup, ProductGroupFormValues } from "../productGroupTypes"
import { DateTimeFactory } from "../../../../localization/useDateTime"

export const prepareProductGroup = (
    values: ProductGroupFormValues,
    dateTimeFactory: DateTimeFactory,
): CreateProductGroup => {
    const { name, isActive, productGroupCode, weekDays, timeIntervalStart, timeIntervalEnd, isLocked, availableTime } =
        values

    const productGroupCodeBody = productGroupCode
        ? {
              productGroupCode: {
                  id: productGroupCode.id,
              },
          }
        : {}

    return {
        name,
        isActive,
        ...productGroupCodeBody,
        securitySettings: {
            isLocked,
        },
        ...(availableTime
            ? {
                  availabilityDetails: {
                      weekDays,
                      timeInterval: {
                          start: dateTimeFactory.formatTime(timeIntervalStart),
                          end: dateTimeFactory.formatTime(timeIntervalEnd),
                      },
                  },
              }
            : {}),
    }
}
